export const formatHeroCounterValue = (
	value: number,
	locale: string,
): string => {
	if (value >= 1000) {
		return `${new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(Math.floor(value / 100) / 10)}K`
	}
	return new Intl.NumberFormat(locale).format(value)
}
